import React from 'react'
import connect from "react-redux/es/connect/connect"
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Typography from '@material-ui/core/Typography'
import AddIcon from '@material-ui/icons/AddCircle'
import RemoveIcon from '@material-ui/icons/RemoveCircle'


import styles from 'common/components/style'


import DialogTitle from 'common/components/dialog/DialogTitle'
import DialogContent from 'common/components/dialog/DialogContent'
import DialogActions from 'common/components/dialog/DialogActions'

import {
  entityChooserValidateSet,
  entityChooserGetConfirmationSummary,
  entityChooserConfirm,
  hideAddEntitiesDialog,
} from '../../../redux/admin/Actions'
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import ToggleIconButton from "common/components/ToggleIconButton";


class AddYearEntityChooserDialogClass extends React.Component {

  render() {
    if (!this.props.entityChooser.entities) return null
    const { classes, entityChooserValidateSet, entityChooserGetConfirmationSummary, entityChooserConfirm, hideAddEntitiesDialog } = this.props
    const { entities, confirmationSummary } = this.props.entityChooser

    return (
      <Dialog
        onClose={hideAddEntitiesDialog}
        aria-labelledby="customized-dialog-title"
        open
      >
        <DialogTitle id="customized-dialog-title" onClose={hideAddEntitiesDialog}>
          Entities used by SchoolTRAK
        </DialogTitle>
        <DialogContent className={classes.dialogContentRoot}>
          {confirmationSummary
            ?
            <>
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
                <AddIcon style={{ marginRight: 8, color: '#757575' }} />
                <Typography variant="h6">Entities to be Enabled</Typography>
              </div>
              {confirmationSummary.enableEntities.length === 0
                ?
                <Typography style={{ paddingLeft: 16 }}>No entities to be enabled.</Typography>
                :
                <List>
                  {confirmationSummary.enableEntities.map((entity) => {
                    return <ListItem key={entity.id} style={{ display: 'block' }}>
                      <div>{entity.displayName}</div>
                      {entity.affectedStudentsCount > 0 &&
                        <List>
                          <ListItem>
                            <span style={{ whiteSpace: 'nowrap' }}>Students to be activated: {entity.affectedStudentsCount}</span>
                          </ListItem>
                        </List>
                      }
                    </ListItem>
                  })}
                </List>
              }
              <div style={{ display: 'flex', alignItems: 'center', marginTop: '8px' }}>
                <RemoveIcon style={{ marginRight: 8, color: '#757575' }} />
                <Typography variant="h6">Entities to be Disabled</Typography>
              </div>
              {confirmationSummary.disableEntities.length === 0
                ?
                <Typography style={{ paddingLeft: 16 }}>No entities to be disabled.</Typography>
                :
                <>
                  <List>
                    {confirmationSummary.disableEntities.map((entity) => {
                      return (
                        <ListItem key={entity.id} style={{ display: 'block' }}>
                          <div>{entity.displayName}</div>
                          {entity.affectedStudentsCount > 0 &&
                            <List>
                              <ListItem>
                                <span style={{ whiteSpace: 'nowrap' }}>Students to be deactivated: {entity.affectedStudentsCount}</span>
                              </ListItem>
                            </List>
                          }
                        </ListItem>
                      )
                    })}
                  </List>
                  <Typography style={{ paddingLeft: 16, color: '#d32f2f' }}>Students will be disabled. They will be deleted during the next school year migration, or you can delete them in the Students Data Cleanup tab.</Typography>
                </>
              }
            </>
            :
            <>
              <Typography>Choose which Entities will be used by SchoolTRAK</Typography>
              <List>
                {entities.map((entity) => {
                  return <ListItem title={`id: ${entity.id}`} key={entity.id}><ToggleIconButton isOn={entity.isEnabled} onClick={() => entityChooserValidateSet({ id: entity.id, isEnabled: !entity.isEnabled })} />{entity.displayName}</ListItem>
                })}
              </List>
            </>
          }
        </DialogContent>
        <DialogActions>
          <Button onClick={hideAddEntitiesDialog} color="secondary">
            Cancel
          </Button>
          {confirmationSummary
            ?
            <>
              <Button onClick={entityChooserConfirm} color="primary">
                Confirm
              </Button>
            </>
            :
            <>
              <Button onClick={entityChooserGetConfirmationSummary} color="primary">
                Next
              </Button>
            </>
          }
        </DialogActions>
      </Dialog>
    )
  }
}

export const AddYearEntityChooserDialog = connect(
  state => state.admin,
  {
    entityChooserValidateSet,
    entityChooserGetConfirmationSummary,
    entityChooserConfirm,
    hideAddEntitiesDialog,
  }
)(withStyles(styles, { withTheme: true })(AddYearEntityChooserDialogClass))

export default AddYearEntityChooserDialog
